import { motion } from "framer-motion";
import { Layers, GraduationCap, Award, Bot } from "lucide-react";

const STATS = [
  {
    icon: Layers,
    value: "3",
    label: "Connected Ventures",
    subtext: "Admissions, Counselling & Tutoring",
    accent: "from-[#0B5D4B] to-[#0D9488]",
  },
  {
    icon: GraduationCap,
    value: "400+",
    label: "Global Placements",
    subtext: "Top institutions in India, US & UK",
    accent: "from-[#B88728] to-[#D4AF37]",
  },
  {
    icon: Award,
    value: "15+ Yrs",
    label: "Mentor Experience",
    subtext: "Certified psychometric & career leads",
    accent: "from-[#064E3B] to-[#0B5D4B]",
  },
  {
    icon: Bot,
    value: "24/7",
    label: "AskPurple AI",
    subtext: "One shared intelligence guide",
    accent: "from-[#4F46E5] to-[#6366F1]",
  },
];

export default function StatsRibbon() {
  return (
    <section className="relative z-10 px-4 py-8 sm:px-6">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-2 gap-3.5 sm:gap-5 lg:grid-cols-4">
          {STATS.map((stat, idx) => {
            const Icon = stat.icon;
            return (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: idx * 0.08 }}
                whileHover={{ y: -4, transition: { duration: 0.2 } }}
                className="group relative overflow-hidden rounded-2xl border border-slate-200/80 bg-white/80 p-4 sm:p-5 shadow-[0_8px_30px_rgb(0,0,0,0.03)] backdrop-blur-xl transition-all hover:border-[#0B5D4B]/30 hover:shadow-[0_12px_36px_rgba(11,93,75,0.06)]"
              >
                {/* Background glow hover effect */}
                <div className="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full bg-gradient-to-br from-white/0 to-[#C89B3C]/10 blur-xl transition-opacity group-hover:opacity-100" />

                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 sm:h-11 sm:w-11 items-center justify-center rounded-xl bg-slate-100/80 text-[#0B5D4B] ring-1 ring-slate-200/70 transition-transform duration-300 group-hover:scale-110 group-hover:bg-[#0B5D4B] group-hover:text-white">
                    <Icon size={20} />
                  </div>
                  <div>
                    <p className={`text-2xl sm:text-3xl font-bold tracking-tight bg-gradient-to-r ${stat.accent} bg-clip-text text-transparent`}>
                      {stat.value}
                    </p>
                    <p className="text-xs sm:text-sm font-semibold text-[#063B30]">
                      {stat.label}
                    </p>
                  </div>
                </div>
                <p className="mt-2 text-[11px] sm:text-xs text-gray-500 line-clamp-1">
                  {stat.subtext}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
